import { SiteOwnership } from "@inrange/building-manager-api-client/models-site";

const isSiteOwnerOccupied = (siteOwnerships: SiteOwnership[]) => {
  const isOwnerOccupied = siteOwnerships.some(
    (siteOwnerhip) => siteOwnerhip.ownership === "ownerOccupier"
  );
  return isOwnerOccupied;
};

export default isSiteOwnerOccupied;
